// [VALIDATION-COMPTE] - Écran affiché quand le compte n'est pas encore validé
import { Lock, Clock, ShieldCheck } from "lucide-react";

export default function ValidationPendingScreen({ boutiqueName, boutiqueSlug }) {
  const whatsappMessage = encodeURIComponent(
    `Bonjour, je viens de créer ma boutique "${boutiqueName || 'Ma Boutique'}" sur BoutiqueOS et j'attends la validation de mon compte.`
  );
  const whatsappLink = `https://wa.me/?text=${whatsappMessage}`;

  return (
    <div className="validation-pending-screen" data-testid="validation-pending-screen">
      {/* Icon */}
      <div className="validation-icon-wrapper">
        <div className="validation-icon-bg">
          <Lock className="validation-lock-icon" />
        </div>
        <div className="validation-pulse-ring" />
      </div>

      {/* Title */}
      <h1 className="validation-title">Compte en cours de validation</h1>

      {/* Description */}
      <p className="validation-description">
        Votre boutique a été créée avec succès. Notre équipe vérifie votre dossier 
        et activera votre compte sous 24h ouvrées.
      </p>

      {/* Info box */}
      <div className="validation-info-box">
        <div className="info-item-row success">
          <ShieldCheck size={16} />
          <span>Accès actuel : Caisse uniquement</span>
        </div>
        <div className="info-divider" />
        <div className="info-item-row pending">
          <Clock size={16} />
          <span>En attente d'activation :</span>
        </div>
        <ul className="pending-features">
          <li>Dashboard & Statistiques</li>
          <li>Gestion Produits & Stock</li>
          <li>Espace Clientes</li>
          <li>Commandes & Messages</li>
          <li>Paramètres boutique</li>
        </ul>
      </div>

      {/* WhatsApp button */}
      <a 
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
        data-testid="validation-whatsapp-btn"
      >
        Contacter le support
      </a>

      {/* Reference */}
      <p className="validation-ref">
        Référence boutique : {boutiqueSlug || 'N/A'}
      </p>

      <style>{`
        .validation-pending-screen {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 65vh;
          padding: 40px 24px;
          text-align: center;
        }

        .validation-icon-wrapper {
          position: relative;
          width: 80px;
          height: 80px;
          margin-bottom: 24px;
        }

        .validation-icon-bg {
          width: 80px;
          height: 80px;
          border-radius: 20px;
          background: linear-gradient(135deg, #FF4500 0%, #CC3700 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 1;
        }

        .validation-lock-icon {
          width: 32px;
          height: 32px;
          color: white;
        }

        .validation-pulse-ring {
          position: absolute;
          inset: -6px;
          border-radius: 24px;
          border: 2px solid rgba(255, 69, 0, 0.3);
          animation: pulseRing 2s ease-out infinite;
        }

        @keyframes pulseRing {
          0% { transform: scale(1); opacity: 1; }
          100% { transform: scale(1.3); opacity: 0; }
        }

        .validation-title {
          color: hsl(var(--foreground));
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 12px;
        }

        .validation-description {
          color: hsl(var(--muted-foreground));
          font-size: 15px;
          line-height: 1.6;
          max-width: 400px;
          margin: 0 0 28px 0;
        }

        .validation-info-box {
          background: hsl(var(--card));
          border: 1px solid hsl(var(--border));
          border-radius: 14px;
          padding: 20px 24px;
          max-width: 380px;
          width: 100%;
          text-align: left;
        }

        .info-item-row {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          font-weight: 500;
        }

        .info-item-row.success {
          color: #22C55E;
        }

        .info-item-row.pending {
          color: #F59E0B;
        }

        .info-divider {
          height: 1px;
          background: hsl(var(--border));
          margin: 12px 0;
        }

        .pending-features {
          list-style: none;
          padding: 0;
          margin: 10px 0 0 26px;
        }

        .pending-features li {
          color: hsl(var(--muted-foreground));
          font-size: 13px;
          padding: 3px 0;
          position: relative;
          padding-left: 14px;
        }

        .pending-features li::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: hsl(var(--muted-foreground));
          opacity: 0.4;
        }

        .whatsapp-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #25D366;
          color: white;
          font-weight: 600;
          font-size: 15px;
          padding: 14px 28px;
          border-radius: 12px;
          text-decoration: none;
          margin-top: 28px;
          transition: all 200ms;
        }

        .whatsapp-btn:hover {
          background: #20BD5A;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
        }

        .validation-ref {
          color: hsl(var(--muted-foreground));
          font-size: 12px;
          margin-top: 20px;
          opacity: 0.6;
        }
      `}</style>
    </div>
  );
}
